module.exports = __webpack_public_path__ + "img/LATIN10_25.fe251287.jpg";